/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartRangeArea = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 6.6v-5l-13.4 5-2.1.8L4 7.1V2H2v20h20v-2H4v-.3l4.1-1.8 2.8-2.8L22 17.2v-4.9L16.4 10l.3-.3L22 6.6zM6.9 16.2 4 17.5V15h4.1l-1.2 1.2zM20 14.8 11.2 13H4V9.1l6.7.8 9.3 3.7v1.2zm-8.6-6.7-.8-.1L20 4.4v1l-4.5 2.7-1.1 1.1-3-1.1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartRangeArea as ChartRangeArea };
